export default __webpack_public_path__ + "4a0ce5ffd016da499d8211ee16a6226a.svg";